import HomePage from "./pages/homepage/home-page";
import {createBrowserRouter} from "react-router-dom";
import {Login} from "./pages/login/login";
import {Register} from "./pages/register/register";
import AboutUs from "./pages/about-us/about-us";
import Resources from "./pages/resources/resources";
import UserProfile from "./components/user-profile/user-profile";
import ProtectedRoute from "./components/protected-route/protected-route";
import AdminRoute from "./components/admin-route/admin-route";
import Unauthorized from "./pages/unauthorized/unauthorized";
import AdminDashboard from "./pages/admin/admin-dashboard";
import BlogsPage from "./pages/admin/blogs/blogs-page";
import BlogEditorPage from "./pages/admin/blogs/blog-editor-page";
import UsersPage from "./pages/admin/users/users-page";
import PublicBlogsPage from "./pages/blogs/blogs-page";
import BlogPostPage from "./pages/blogs/blog-post-page";
import CalendarPage from "./pages/calendar/calendar-page";

export const userRoutes = [
    {
        path: '/login',
        name: 'Login',
        element: <Login />
    },
    {
        path: '/register',
        name: 'Register',
        element: <Register />,
        isDisabled: true,
    }
]

export const protectedRoutes = [
    {
        path: '/profile',
        name: 'Profile',
        element: <ProtectedRoute><UserProfile /></ProtectedRoute>
    }
]

export const adminRoutes = [
    {
        path: '/admin',
        name: 'Admin Dashboard',
        element: <AdminRoute><AdminDashboard /></AdminRoute>
    },
    {
        path: '/admin/blogs',
        name: 'Blog Management',
        element: <AdminRoute><BlogsPage /></AdminRoute>
    },
    {
        path: '/admin/blogs/new',
        name: 'Create Blog',
        element: <AdminRoute><BlogEditorPage /></AdminRoute>
    },
    {
        path: '/admin/blogs/edit/:blogId',
        name: 'Edit Blog',
        element: <AdminRoute><BlogEditorPage /></AdminRoute>
    },
    {
        path: '/admin/users',
        name: 'User Management',
        element: <AdminRoute><UsersPage /></AdminRoute>
    }
]

export const mainRoutes = [
    {
        path: '/',
        element: <HomePage />,
        name: 'Home'
    },
    {
        path: '/about-us',
        element: <AboutUs />,
        name: 'About Us'
    },
    {
        path: '/resources',
        name: 'Resources',
        element: <Resources />
    },
    {
        path: '/blogs',
        name: 'Blogs',
        element: <PublicBlogsPage />
    },
    {
        path: '/calendar',
        name: 'Event Calendar',
        element: <CalendarPage />
    },
];

export const blogRoutes = [
    {
        path: '/blogs/:blogId',
        element: <BlogPostPage />
    }
];

export const router = createBrowserRouter([
    {
        path: '/',
        element: <HomePage />,
    },
    {
        path: '/unauthorized',
        element: <Unauthorized />,
    },
    ...mainRoutes,
    ...blogRoutes,
    ...userRoutes,
    ...protectedRoutes,
    ...adminRoutes,
]);
